'use strict';

const isSmallView = require('../../modules/helpers/isSmallView');
const $imageColumn = $('.js-collection-image-column');

function imageSwitcher() {
    const $imagePlaceholder = $('.js-collection-mobile-placeholder');
    const $imageHolderDesktop = $imageColumn.find('.js-image-holder');
    const $imageHolderMobile = $imagePlaceholder.find('.js-image-holder');

    if (isSmallView()) {
        if ($imageHolderMobile.length < 1) {
            $imagePlaceholder.prepend($imageHolderDesktop);
        }
    } else {
        if ($imageHolderDesktop.length < 1) {
            $imageColumn.prepend($imageHolderMobile);
        }
    }
}

//do not tab through the product name except on the product slider
function removeFocus() {
    $imageColumn.parent().find('.js-product-name-link').attr('tabindex', '-1');
}

/**
 * @description Initialize block
 */
function initBlock() {
    imageSwitcher();
    removeFocus();
}

/**
 * @description Initialize event handlers for the discover block
 */
function initializeEvents() {
    $(window).on('resize', function () {
        imageSwitcher();
    });
}

const highlight = {
    init: function() {
        initBlock();
        initializeEvents();
    }
};

module.exports = highlight;
